// @flow
// $FlowFixMe
import React, { Fragment } from 'react';
import { convertToRaw } from 'draft-js';
import type { Editor } from 'draft-js';
import type { UserType, CommentType, AuthorType } from '../../types';
import { NotLoggedIn, ShowMoreBlock, ShowMore } from '../';
import { PendingModerationAlert } from '../PendingModerationAlert';
import { CommentList, Comment, PostComment } from './partials';

type Props = {
  questionURL: string,
  comments: Array<CommentType>,
  user: UserType,
  authors: {
    [key: string]: AuthorType
  },
  handleDeleteComment: Function,
  handleAddComment: Function
};

type State = {
  showRestComments: boolean,
  justCommented: boolean,
  newComment: Object
};

export class Comments extends React.Component<Props, State> {
  // TODO Change any for HTMLElement, and fix Flow...
  commentContainer: any;
  commentEditor: Editor;

  state = {
    showRestComments: false,
    justCommented: false,
    newComment: null
  };

  focusEditor = () => {
    this.commentEditor && this.commentEditor.focus();
  };

  handleReturn = (products: Array<Object>, cb: Function) => {
    const content = this.commentEditor.props.editorState.getCurrentContent();

    // Don't handle return if this conditions are met.
    if (!content.hasText()) return;
    if (content.getPlainText().length > 600) return;

    // Extracting editors RAW content and plain text.
    const rawContent = convertToRaw(content);
    const plainText = content.getPlainText();

    const newComment = {
      rawContent,
      plainText,
      products
    };

    this.props.handleAddComment(newComment);
    this.setState({ justCommented: true, newComment });

    cb();
  };

  showRestComments = () => {
    this.setState({ showRestComments: true });
  };

  renderComment = (comment: CommentType) => {
    const author = this.props.authors[comment.author];
    const { user, handleDeleteComment } = this.props;

    return (
      <Comment
        key={comment.id}
        comment={comment}
        author={author}
        isAuthor={user.id === author.id}
        deleteComment={handleDeleteComment}
      />
    );
  };

  render() {
    const { comments, authors, user, handleDeleteComment, questionURL } = this.props;
    const { justCommented } = this.state;
    const commentQty = comments.length;
    let showComments = comments;
    let hiddenComments;
    let restComments;

    if (commentQty > 3) {
      showComments = comments.slice(commentQty - 3, commentQty);
      hiddenComments = comments.slice(0, commentQty - 3);
      restComments = `Mostrar ${hiddenComments.length} comentario${hiddenComments.length > 1 ? 's' : ''} más`;
    }

    return (
      <CommentList ref={el => (this.commentContainer = el)}>
        {commentQty ? (
          <Fragment>
            {hiddenComments ?
              this.state.showRestComments ?
                hiddenComments.map(this.renderComment)
                : (
                  <ShowMoreBlock small>
                    <ShowMore onClick={this.showRestComments}>{restComments}</ShowMore>
                  </ShowMoreBlock>
                )
              : null}
            {showComments.map((comment) => {
              const author = authors[comment.author];
              return (
                <Comment
                  key={comment.id}
                  comment={comment}
                  author={author}
                  isAuthor={user.id === author.id}
                  deleteComment={handleDeleteComment}
                  loggedIn={user.isLoggedIn}
                />
              );
            })}
          </Fragment>
        ) : null}

        {justCommented ? <PendingModerationAlert type="comment" /> : null}
        {/* {justCommented ? <Fragment>
          <Comment
            key="1"
            comment={newComment}
            author={user}
            isAuthor={true}
            deleteComment={handleDeleteComment}
            loggedIn={user.isLoggedIn}
          />
        </Fragment> : null} */}

        {user.isLoggedIn ? (
          <PostComment
            inputRef={el => (this.commentEditor = el)}
            user={user}
            defaultValue="Escribe tu comentario"
            focusEditor={this.focusEditor}
            handleReturn={this.handleReturn}
          />
        ) : (
          <NotLoggedIn url={questionURL} msg="compartir tu comentario" center />
        )}
      </CommentList>
    );
  }
}
